
import { Component,OnInit, TemplateRef } from '@angular/core';
import { Router } from '@angular/router';
import { breadcrumbItem } from 'src/app/components/breadcrumbs/breadcrumbs.model';
import { BreadcrumbService } from "src/app/services/breadcrumb";

import { ChartType } from './apex.model';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import {
  linewithDataChart, basicColumChart, columnlabelChart, lineColumAreaChart,
  basicRadialBarChart, simplePieChart, donutChart, barChart, splineAreaChart, dashedLineChart
} from './data';
import {NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { HttpHeaders } from '@angular/common/http';
import { ApiService } from 'src/app/services/api';
import { HttpClient, HttpParams } from '@angular/common/http';
import { setLoadingSpinner } from 'src/app/store/sharedstate/shared.actions';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { AlertService } from 'src/app/core/services/AlertService/alert.service';
import { CookieService } from 'ngx-cookie-service';
import { ActivatedRoute } from '@angular/router';
import { TimezoneService } from 'src/app/services/timezone';
@Component({
   selector: "app-network-overview",
   templateUrl: "./network-overview.component.html",
   styleUrls: ["./network-overview.component.scss"],
})


export class NetworkOverviewComponent implements OnInit{
   breadcrumbItems: breadcrumbItem[] = [
      {
         label: "Home",
         active: false,
         url: "/home",
      },
      {
         label: "Employees",
         active: false,
         url: "/employees/jobtypes/employee-stup-home",
         // url:"/employees/jobtypes"
      },
      {
         label: "Site Network Details",
         active: true,
         url: "",
      },
   ];


   breadCrumbItems: Array<{}>;

  linewithDataChart: ChartType;
  basicColumChart: ChartType;
  columnlabelChart: ChartType;
  lineColumAreaChart: ChartType;
  basicRadialBarChart: ChartType;
  simplePieChart: ChartType;
  donutChart: ChartType;
  barChart: ChartType;
  splineAreaChart: ChartType;
  dashedLineChart: ChartType;
   numbers: number[] = [];

   GLOBALURL: any;
   headerToken = { 'Content-Type': 'application/json', 'Authorization': this.cookieService.get('token') };
   httpOptions = { headers: new HttpHeaders(this.headerToken) };

   sites: any = [];
   hostId: string = "";
   host: any;

   latitude: any;
   longitude: any;
   wifiCount: ChartType;

   startDate: any;
   endDate: any;
   progressBarData: any;
   Timezone: any;

   constructor(
      private router: Router,
      private BreadcrumbService: BreadcrumbService,
      private offcanvasService: NgbOffcanvas,
      private cookieService: CookieService,
      private ApiService: ApiService,
      private http: HttpClient,
      private store: Store<AppState>,
      private toastr: AlertService,
      private activatedRoute: ActivatedRoute,
      private timezoneService: TimezoneService,
   ) {
    this.numbers = Array.from({ length: 36 }, (_, index) => index + 1);
    this.GLOBALURL = this.ApiService.getBaseURL();
    this.hostId = this.activatedRoute.snapshot.params.id;
    this.Timezone = this.timezoneService.get();
    this.startDate = this.Timezone().startOf('day');
    this.endDate = this.Timezone();
  }

   ngOnInit() {
      this.store.dispatch(setLoadingSpinner({ status: true }));
      this.BreadcrumbService.setValue(this.breadcrumbItems);
      this.breadCrumbItems = [{ label: 'Charts' }, { label: 'Apex charts', active: true }];

      /**
       * Fethches the chart data
       */
      this._fetchData();
      this.getSitesList();
   }

   getSitesList() {
    this.http.get(this.GLOBALURL + "/ubiquiti/sites", this.httpOptions)
      .subscribe((response: any) => {
        this.sites = response.data;
        // this.getAllHosts();
        this.getHostById(this.hostId);
      },
      (error) => {
        console.error("Error getting sites list:", error);
      });
  }

  ipAddresses: any = [];
  getHostById(hostId: any) {
    this.http.get(this.GLOBALURL + "/ubiquiti/hostById?id=" + hostId, this.httpOptions)
      .subscribe((response: any) => {
        this.host = response.data;

        if (this.host) {
          // console.log("SITES", this.sites);
          let foundHost = this.sites.find(site => this.host.id === site.hostId);

          // console.log("Found Host: ", foundHost);
          if (foundHost) {
            this.host.statistics = foundHost.statistics;
            console.log("HOST", this.host);
          }

          if (this.host?.statistics?.internetIssues?.length > 0) {
            // console.log("INTERNET ISSUES IN 5 MINS", this.host?.reportedState?.internetIssues5min);
            // console.log("CALCULATED TIME STAMPS", this.calculateTimestamps(this.host.statistics.internetIssues));
            this.host.statistics.internetIssues = this.calculateTimestamps(this.host.statistics.internetIssues);
          }

          this.host.reportedState.ipAddrs.forEach((ip) => {
            if (this.isIPv4Address(ip)) {
              this.ipAddresses.push(ip);
            }
          });
          console.log("IP ADDRESSES", this.ipAddresses);

          let labels = Object.entries(this.host.statistics.counts)
          .filter(([key, value]) => value)
          .map(([key, value]) => this.toTitleCase(key));

          this.wifiCount = {
            chart: {
              height: 350,
              type: "donut",
            },
            series: Object.values(this.host.statistics.counts).filter(val => val),
            legend: {
              show: true,
              position: "right",
              horizontalAlign: "center",
              verticalAlign: "middle",
              floating: false,
              fontSize: "14px",
              offsetX: 0,
              offsetY: -10,
            },
            labels: labels,
            colors: [
              "#8E44AD",
              "#2ECC71",
              "#E74C3C",
              "#3498DB",
              "#F39C12",
              "#1F8A70",
              "#D35400",
              "#9B59B6",
              "#16A085",
              "#C0392B",
              "#F1C40F",
              "#34495E",
              "#E67E22",
              "#27AE60",
              "#2980B9",
              "#8E44AD"
            ].filter((val, index) => index < labels.length),
            responsive: [
              {
                breakpoint: 600,
                options: {
                  chart: {
                    height: 240,
                  },
                  legend: {
                    show: false,
                  },
                },
              },
            ],
          };

          this.getDevices(this.host.latestBackupTime);
        }
        // console.log("KEYS", Object.keys(this.host.statistics.counts).map((val) => this.toTitleCase(val)))
        // console.log("VALUES", Object.values(this.host.statistics.counts))


        this.store.dispatch(setLoadingSpinner({ status: false }));
      },
      (error) => {
        console.error("Error getting host: ", error);
        this.store.dispatch(setLoadingSpinner({ status: false }));
      });
  }

  isIPv4Address(inputString) {
    const ipv4Pattern = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;
    const match = inputString.match(ipv4Pattern);
    if (match) {
        return match.slice(1).every(group => {
            const num = parseInt(group, 10);
            return num >= 0 && num <= 255;
        });
    }
    return false;
  }

  convertedDates: any = {};
  convertDate = (date: any) => {
    if (!this.convertedDates[date]) {
      if (date) {
        // console.log("DATE", this.Timezone(date));
        this.convertedDates[date] = this.Timezone(date)
          .format("MMM DD, YYYY hh:mm A");

        // console.log("CONVERTED DATES", this.convertedDates);
      } else {
        return "N/A";
      }
    }

    return this.convertedDates[date];
  };

  toTitleCase(str) {
    const words = str.split(/(?=[A-Z])/);
    return words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  }

  devices: any = [];
  getDevices(time: any) {
    let params = new HttpParams();

    params = params.append('hostIds', this.hostId);
    params = params.append('time', time);

    this.http.get(this.GLOBALURL + "/ubiquiti/devices", { headers: this.headerToken, params: params })
      .subscribe((response: any) => {
        if (response?.data) {
          response.data.forEach((val) => {
            val.devices?.forEach((device) => {
              this.devices.push(device);
            });
          });
        }
        console.log("DEVICES", this.devices);
      },
      (error) => {
        console.error("Error getting devices: ", error);
      });
  }

  calculateTimestamps = (issues: any[]) => {
    console.log("START TIMESTAMP", this.startDate.format('YYYY-MM-DD HH:mm:ss'));
    return issues.map(issue => {
      // const minutesOffset = (issue.index - issues[0].index) * intervalInMinutes;
      // const secondsOffset = issue.index;
      const millisecondsOffset = issue.index;
      const totalDuration = this.endDate.diff(this.startDate, 'milliseconds');
      // console.log("SEC OFFSET", millisecondsOffset);
      const issueTimestamp = this.startDate.clone().add(millisecondsOffset, 'milliseconds');
      const issueDuration = issueTimestamp.diff(this.startDate, 'milliseconds');
      const percentage = (issueDuration / totalDuration) * 100;
      return {
        ...issue,
        timestamp: issueTimestamp.format('hh:mm:ss a'),
        percentage,
      };
    });
  };

   private _fetchData() {
      this.linewithDataChart = linewithDataChart;
      this.basicColumChart = basicColumChart;
      this.columnlabelChart = columnlabelChart;
      this.lineColumAreaChart = lineColumAreaChart;
      this.basicRadialBarChart = basicRadialBarChart;
      this.simplePieChart = simplePieChart;
      this.donutChart = donutChart;
      this.barChart = barChart;
      this.splineAreaChart = splineAreaChart;
      this.dashedLineChart = dashedLineChart;
    }


    OpenFilterCanva(content1: TemplateRef<any>) {
      this.offcanvasService.open(content1, { position: "end" });
    }


    selectedTab: number = 1;

    selectTab(tab: number) {
      this.selectedTab = tab;
    }



}




